import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { E11AccordionModule } from '@engineering11/ui-lib/e11-accordion'
import { E11AvatarModule } from '@engineering11/ui-lib/e11-avatar'
import { E11BackdropModule } from '@engineering11/ui-lib/e11-backdrop'
import { E11BadgeModule } from '@engineering11/ui-lib/e11-badge'
import { E11ButtonModule } from '@engineering11/ui-lib/e11-button'
import { E11CardModule } from '@engineering11/ui-lib/e11-card'
import { E11ChartPercentageModule } from '@engineering11/ui-lib/e11-chart-percentage'
import { E11ChipModule } from '@engineering11/ui-lib/e11-chip'
import { E11DividerModule } from '@engineering11/ui-lib/e11-divider'
import { E11EmptyStateModule } from '@engineering11/ui-lib/e11-empty-state'
import { E11ImageCropperModuleModule } from '@engineering11/ui-lib/e11-image-cropper'
import { E11InputModule } from '@engineering11/ui-lib/e11-input'
import { E11InputErrorsModule } from '@engineering11/ui-lib/e11-input-errors'
import { E11LoaderSpinnerModule } from '@engineering11/ui-lib/e11-loader-spinner'
import { E11ModalModule } from '@engineering11/ui-lib/e11-modal'
import { E11MultiSelectModule } from '@engineering11/ui-lib/e11-multi-select'
import { E11NavLeftModule } from '@engineering11/ui-lib/e11-nav-left'
import { E11PanelModule } from '@engineering11/ui-lib/e11-panel'
import { E11ProfilePicModule } from '@engineering11/ui-lib/e11-profile-pic'
import { E11RadioInputModule } from '@engineering11/ui-lib/e11-radio-input'
import { E11SelectModule } from '@engineering11/ui-lib/e11-select'
import { E11SideOverModule } from '@engineering11/ui-lib/e11-side-over'
import { E11SidesheetModule } from '@engineering11/ui-lib/e11-sidesheet'
import { E11SwitchModule } from '@engineering11/ui-lib/e11-switch'
import { E11TextEditorModule } from '@engineering11/ui-lib/e11-text-editor'
import { E11TitleBarModule } from '@engineering11/ui-lib/e11-title-bar'
import { E11TooltipModule } from '@engineering11/ui-lib/e11-tooltip'
import { LoaderLinkComponent, LoaderLinkGlobalComponent } from 'shared-lib'

const ImportExportModules = [
  // New E11 Modules
  E11AccordionModule,
  E11BackdropModule,
  E11BadgeModule,
  E11ButtonModule,
  E11CardModule,
  E11ChartPercentageModule,
  E11ChipModule,
  E11DividerModule,
  E11EmptyStateModule,
  E11InputModule,
  E11ModalModule,
  E11RadioInputModule,
  E11PanelModule,
  E11ProfilePicModule,
  E11TitleBarModule,
  E11SideOverModule,
  E11TextEditorModule,
  LoaderLinkComponent,
  LoaderLinkGlobalComponent,
  E11LoaderSpinnerModule,
  E11SidesheetModule,
  E11TooltipModule,
  E11ImageCropperModuleModule,
  E11MultiSelectModule,
  E11InputErrorsModule,
  E11SelectModule,
  E11SwitchModule,
  E11AvatarModule,
  E11NavLeftModule,
]

@NgModule({
  declarations: [],
  imports: [CommonModule, ...ImportExportModules],
  exports: [...ImportExportModules],
})
export class E11ComponentLibraryModule {}
